import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const SearchRoutes: RouteBundle = {
  domain: 'search',
  routes: [{urlPattern: 'search', handler: EditorRoutes.search.bind(EditorRoutes), legacy: true}],
};
